var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { HDSButton } from "@here/hds-react-components/Button";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import translations from "../../translations/resources/en-GB.json";
import { ButtonText } from "./constant";
import { handleOrder3dMap } from "./helper";
import "./internalToolsPage.scss";
import { useUserInfo } from "../../hooks";
import NoRealmSetup from "../noRealmSetup/NoRealmSetup";
import { InternalTabs } from "./components";
import utils from "../../store/helpers/indoorHelper";
import "../../pages/Overview/overview.scss";
var InternalTools = function (props) {
    var collectionMetaList = props.collectionMetaList;
    var userInfo = useUserInfo();
    var history = useHistory();
    var mapCollectionSelected = useSelector(function (state) { return state === null || state === void 0 ? void 0 : state.app.mapCollectionSelected; });
    var isLoading = useSelector(function (state) { return state === null || state === void 0 ? void 0 : state.app.collectionLoaded; });
    var reamlSetup = useSelector(function (state) { return state === null || state === void 0 ? void 0 : state.app.isRealmSetup; });
    var isAuthorizedForRealmSetup = useSelector(function (state) { return state === null || state === void 0 ? void 0 : state.app.isAuthorizedForRealmSetup; });
    var showOrder3dButton = utils.isRealmAllowed(userInfo.realm);
    return (_jsx(_Fragment, { children: _jsxs("div", __assign({ className: "containerBox" }, { children: [_jsxs("div", __assign({ className: "internalToolsHeader" }, { children: [_jsx("div", __assign({ className: "internalToolsHeading" }, { children: translations.data["venonboard.internalTools.heading"] })), _jsx("div", __assign({ className: "action-buttons" }, { children: showOrder3dButton && (_jsx(HDSButton, __assign({ id: "order-3d-maps", size: "medium", type: "button", variant: "secondary", width: "129px", onClick: handleOrder3dMap.bind(null, history), "data-cy": "order-3d-maps-button" }, { children: ButtonText.ORDER_3D_MAP }))) }))] })), !reamlSetup && isAuthorizedForRealmSetup ? (_jsx(NoRealmSetup, {})) : (_jsx(InternalTabs, { mapCollectionSelected: mapCollectionSelected, hasMapCollectionLoaded: isLoading, collectionMetaList: collectionMetaList }))] })) }));
};
export default InternalTools;
